
import HttpService from "./htttp.service";

class SubscriptionService {
  // Method to download the profile to the backend
  async fetchSubscription(plan = "") {
    try {
        const endpoint = plan
        ? `/subscription/${plan}`
        : `/subscription`;
      const response = await HttpService.get(endpoint);
      return response;
    } catch (error) {
      console.error("Error fetching subscription:", error);
      throw error;
    }
  }  
}

export default new SubscriptionService();
